import { ActionType } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import React from "react";
import {
    useFranchiseManagementEnabled,
    useIsAllowed,
    useRegionId,
} from "store/selectors/hooks";

interface CommunityFranchiseTerritoriesProps {
    zip: string;
}

export const CommunityFranchiseTerritories: React.FC<
    CommunityFranchiseTerritoriesProps
> = ({ zip }) => {
    const isEnabled = useFranchiseManagementEnabled();
    const canView = useIsAllowed(ActionType.ViewFranchiseTerritories);
    const regionId = useRegionId();

    const trpcClient = trpc.useTRPC();
    const { data, isLoading } = useQuery({
        ...trpcClient.franchiseTerritory.findByZipCode.queryOptions({
            zipCode: zip,
            regionId: regionId!,
        }),
        enabled: isEnabled && canView && !!zip && !!regionId,
    });

    if (!isEnabled || !canView || !zip || isLoading) {
        return null;
    }

    const displayValue =
        data && data.length > 0
            ? data
                  .map(t =>
                      t.assignedRegionName
                          ? `${t.code} (${t.assignedRegionName})`
                          : t.code,
                  )
                  .join(", ")
            : null;

    if (!displayValue) {
        return null;
    }

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700">
                Franchise Territory
            </label>
            <p className="mt-1 text-sm text-gray-900">{displayValue}</p>
        </div>
    );
};
